import React, { memo } from 'react';
import { useDispatch } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { Dispatch } from '@swf/core/store';
import { Icon } from '@swf/sports/components';

import { TXTWCL_Close } from './Header.messages.json';
import styles from './Header.scss';

export interface Props {
  title: React.ReactElement;
}

const Header: React.FC<Props> = ({ title }) => {
  const { betSlip } = useDispatch<Dispatch>();
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.header}>
      <span className={styles.tickIcon}>
        <Icon name="tick-medium" />
      </span>
      <h2>{title}</h2>
      <button
        type="button"
        onClick={() => {
          betSlip.receiptClosed();
          betSlip.betSlipOpened(false);
        }}
        className={styles.button}
      >
        <Icon
          name="close-medium"
          label={formatMessage(TXTWCL_Close)}
          className={styles.closeIcon}
          size="lg"
        />
      </button>
    </div>
  );
};

export default memo(Header);
